import { ConsentSource, SubscriptionSource } from '@ketch-sdk/ketch-types'

export enum ContactMethod {
  Phone = 'phone',
  SMS = 'sms',
  Email = 'email',
  Push = 'push',
  Mail = 'mail',
}

export const ContactMethodLabels: Record<ContactMethod, string> = {
  [ContactMethod.Phone]: 'Phone',
  [ContactMethod.SMS]: 'SMS',
  [ContactMethod.Email]: 'Email',
  [ContactMethod.Push]: 'Push',
  [ContactMethod.Mail]: 'Mail',
}

export const SourceLabels: Record<ConsentSource | SubscriptionSource, string> = {
  [ConsentSource.LegalBasisDefault]: 'Legal Basis Default',
  [ConsentSource.GpcPlugins]: 'GPC Signal',
  [ConsentSource.OneTrustMigrator]: 'OneTrust Migrator',
  [ConsentSource.BannerSaveCurrentState]: 'Banner Save Button',
  [ConsentSource.BannerAcceptAll]: 'Banner Accept All Button',
  [ConsentSource.BannerRejectAll]: 'Banner Reject All Button',
  [ConsentSource.BannerCloseButton]: 'Banner Close Button',
  [ConsentSource.ModalAcceptAll]: 'Modal Accept All Button',
  [ConsentSource.ModalRejectAll]: 'Modal Reject All Button',
  [ConsentSource.ModalDefault]: 'Legal Basis Default',
  [ConsentSource.ModalManual]: 'Modal Consent Switches',
  [ConsentSource.ModalCloseButton]: 'Modal Close Button',
  [ConsentSource.PreferenceConsentsTabAcceptAll]: 'Preference Center Accept All Button',
  [ConsentSource.PreferenceConsentsTabRejectAll]: 'Preference Center Reject All Button',
  [ConsentSource.PreferenceDefault]: 'Legal Basis Default',
  [ConsentSource.PreferenceManual]: 'Preference Center Consent Switches',
  [ConsentSource.RouterSetConsent]: 'Ketch Function Call',
  [ConsentSource.ProgressiveConsent]: 'Progressive Consent Experience',
  [ConsentSource.WorkflowSetPermits]: 'Workflow Set Permits Tile',
  [ConsentSource.PushedFromID]: 'Pushed From ID',
  [ConsentSource.PushedToID]: 'Pushed To ID',
  [ConsentSource.LateArrivingID]: 'Late Arriving ID',
  [ConsentSource.AuditLogAcceptAll]: 'Audit Log Opt In All Button',
  [ConsentSource.AuditLogRejectAll]: 'Audit Log Opt Out All Button',
  [SubscriptionSource.PreferenceSubscriptionsTabManual]: 'Preference Center Individual Subscription Choice',
  [SubscriptionSource.PreferenceSubscriptionsTabUnsubscribeAll]: 'Preference Center Unsubscribe All Button',
  [SubscriptionSource.ProgressiveSubscription]: 'Progressive Subscription Experience',
  [SubscriptionSource.RouterSetSubscriptions]: 'Ketch Function Call',
  [SubscriptionSource.AuditLogSubscribeAll]: 'Audit Log Subscribe to All Button',
  [SubscriptionSource.AuditLogUnsubscribeAll]: 'Audit Log Unsubscribe from All Button',
  headless: 'Headless API Call',
  'auditLog.default': 'Audit Log Reset to Defaults Button',
  'auditLog.manual': 'Audit Log Individual Override',
  [ConsentSource.ConsentGate]: 'Consent Gate Experience',
  [SubscriptionSource.ConsentGateSubscription]: 'Consent Gate Experience',
  [ConsentSource.RouterAcceptAllConsent]: 'Router acceptAllConsent Function Call',
  [ConsentSource.RouterRejectAllConsent]: 'Router rejectAllConsent Function Call',
  unknown: 'Unknown',
}
